<template>
  <Form @submit="onSubmit">
    <draggable
      class="space-y-3 list-none"
      v-model="list"
      :component-data="{
        tag: 'ul',
        type: 'transition-group',
        name: !drag ? 'flip-list' : null,
      }"
      v-bind="dragOptions"
      @start="drag = true"
      @end="drag = false"
      item-key="id"
      id="draggable-list"
    >
      <template #item="{ element }">
        <li class="w-full p-3 bg-white border border-gray-300 rounded-md cursor-move dark:text-white dark:bg-gray-900">
          {{ element }}
        </li>
      </template>
    </draggable>

    <TaskSubmitButton :cta="'Submit'" :correct="answer.correct" @skip="$emit('skip', $event)" />
  </Form>
</template>


<script>
import draggable from "vuedraggable";
import TaskSubmitButton from "../task/TaskSubmitButton.vue";
import { Form } from "vee-validate";
import isEqual from "lodash.isequal";

export default {
  components: {
    draggable,
    TaskSubmitButton,
    Form,
  },
  data() {
    return {
      answer: {
        item: null,
        correct: null,
      },
      list: this.options,
      drag: false,
    };
  },
  props: {
    options: Array,
    solution: Array,
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "!bg-gray-400",
      };
    },
  },
  methods: {
    onSubmit() {
      console.log(options);
      // evaluating the answer
      const options = Array.from(document.getElementById("draggable-list").querySelectorAll("li"));

      const answer = options.map(function (li) {
        return li.textContent.trim();
      });

      // evaluate answer
      const correct = isEqual(answer, this.$props.solution) ? true : false;

      this.answer = {
        item: answer,
        correct: correct,
      };

      this.$emit("answer", this.answer);
    },
  },
};
</script>